import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent } from '@mui/material'
import { DATA_DOMAIN_OPTIONS } from '../types'

interface DataDomainFieldProps {
  value: string
  onChange: (value: string) => void
  label?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const DataDomainField: React.FC<DataDomainFieldProps> = ({
  value,
  onChange,
  label = 'Domain',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <FormControl fullWidth size="small">
        <Select displayEmpty value={value} onChange={handleChange}>
          {DATA_DOMAIN_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default DataDomainField
